'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasePatternFactory = require('../lib/BasePatternFactory');

var _BasePatternFactory2 = _interopRequireDefault(_BasePatternFactory);

var _EmailAddressRegex = require('../regex/EmailAddressRegex');

var _EmailAddressRegex2 = _interopRequireDefault(_EmailAddressRegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _BasePatternFactory2.default)({
  name: 'EmailAddress',
  validator: function validator(input) {
    return _EmailAddressRegex2.default.test(input);
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PatternValidationJS/static-1.81/js/patterns/EmailAddress.js
// module id = 179
// module chunks = 0